// extracted by mini-css-extract-plugin
export default {"well":"_76f675ec","padding":"_b87876f","label":"_cc8695d8"};